import { useState } from 'react';

export default function useAuth(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (body) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include', // manda e riceve cookie (refresh token)
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json?.detail || `Errore: ${response.status}`);
      }

      if (json.access) {
        localStorage.setItem('access_token', json.access); // salva access token
      }

      if (json.refresh) {
        localStorage.setItem('refresh_token', json.refresh);
      }

      setData(json);
      return { data: json, error: null };
    } catch (err) {
      setError(err);
      return { data: null, error: err };
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData };
}
